import { render, staticRenderFns } from "./Toporgbubbleinfluncer.vue?vue&type=template&id=89cd5140"
import script from "./Toporgbubbleinfluncer.vue?vue&type=script&lang=js"
export * from "./Toporgbubbleinfluncer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports